import { Apartment } from "components/ui/apartments-finishing/apartments-finishing";

export const apartmentsList = [
  {
    image: '/assets/images/apartments/23,85.png',
    title: 'Студия, 23,85 м²',
    price: 'от 6,0 млн руб',
    oldPrice: 'от 8,0 млн руб',
    commonSpace: '23,85 м²',
    livingSpace: '12,30 м²',
    dialogTitle: 'Студия',
    priceNumber: 5993505,
    oldPriceNumber: 7989750,
    firstText: 'Скидка 25%',
    secondText: 'Без отделки'
  },
  {
    image: '/assets/images/apartments/4с_25,72.png',
    title: 'Студия, 25,72 м²',
    price: 'от 6,4 млн руб',
    oldPrice: 'от 8,5 млн руб',
    commonSpace: '25,72 м²',
    livingSpace: '12,04 м²',
    dialogTitle: 'Студия',
    priceNumber: 6365700,
    oldPriceNumber: 8487600,
    firstText: 'Скидка 25%',
    secondText: 'Без отделки'
  },
  {
    image: '/assets/images/apartments/1k_33,56.png',
    title: '1-комнатная, 33,56 м²',
    price: 'от 7,3 млн руб',
    oldPrice: 'от 9,7 млн руб',
    commonSpace: '33,56 м²',
    livingSpace: '13,39 м²',
    dialogTitle: 'Однокомнатная квартира',
    priceNumber: 7299300,
    oldPriceNumber: 9732400,
    firstText: 'Скидка 25%',
    secondText: 'Без отделки'
  },
  // {
  //   image: '/assets/images/apartments/1с_31,64.png',
  //   title: '1-комнатная, 31,64 м²',
  //   price: 'от 7,2 млн руб',
  //   oldPrice: 'от 9,6 млн руб',
  //   commonSpace: '31,64 м²',
  //   livingSpace: '12,20 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  //   priceNumber: 7166460,
  //   oldPriceNumber: 9555280,
  //   firstText: 'Скидка 25%',
  //   secondText: 'Без отделки'
  // },
  {
    image: '/assets/images/apartments/1с_35,09.png',
    title: '1-комнатная, 35,09 м²',
    price: 'от 7,5 млн руб',
    oldPrice: 'от 10,0 млн руб',
    commonSpace: '35,09 м²',
    livingSpace: '14,98 м²',
    dialogTitle: 'Однокомнатная квартира',
    priceNumber: 7502242,
    oldPriceNumber: 10000650,
    firstText: 'Скидка 25%',
    secondText: 'Без отделки'
  },
  {
    image: '/assets/images/apartments/2с_36,82.png',
    title: '1-комнатная, 36,82 м²',
    price: 'от 9,0 млн руб',
    oldPrice: 'от 11,6 млн руб',
    commonSpace: '36,82 м²',
    livingSpace: '15,29 м²',
    dialogTitle: 'Однокомнатная квартира',
    priceNumber: 9020900,
    oldPriceNumber: 11598300,
    firstText: 'Скидка 25%',
    secondText: 'White box'
  },
  {
    image: '/assets/images/apartments/40_57.png',
    title: '2-комнатная (евро), 40,57 м²',
    price: 'от 8,2 млн руб',
    oldPrice: 'от 11,0 млн руб',
    commonSpace: '40,57 м²',
    livingSpace: '24,98 м²',
    dialogTitle: 'Двухкомнатная квартира (евро)',
    priceNumber: 8215425,
    oldPriceNumber: 10953900,
    firstText: 'Скидка 25%',
    secondText: 'Без отделки'
  },
  {
    image: '/assets/images/apartments/2с_53,67.png',
    title: '2-комнатная, 53,67 м²',
    price: 'от 12,2 млн руб',
    oldPrice: 'от 15,7 млн руб',
    commonSpace: '53,67 м²',
    livingSpace: '31,48 м²',
    dialogTitle: 'Двухкомнатная квартира',
    priceNumber: 12226026,
    oldPriceNumber: 15671640,
    firstText: 'Скидка 25%',
    secondText: 'White box'
  },
  {
    image: '/assets/images/apartments/1с_42,78.png',
    title: '2-комнатная (евро), 42,78 м²',
    price: 'от 8,5 млн руб',
    oldPrice: 'от 11,3 млн руб',
    commonSpace: '42,78 м²',
    livingSpace: '22,28 м²',
    dialogTitle: 'Двухкомнатная квартира (евро)',
    priceNumber: 8504664,
    oldPriceNumber: 11336700,
    firstText: 'Скидка 25%',
    secondText: 'Без отделки'
  },
  {
    image: '/assets/images/apartments/4с_46,91.png',
    title: '2-комнатная (евро), 46,91 м²',
    price: 'от 11,0 млн руб',
    oldPrice: 'от 14,1 млн руб',
    commonSpace: '46,91 м²',
    livingSpace: '27,66 м²',
    dialogTitle: 'Двухкомнатная квартира (евро)',
    priceNumber: 11000395,
    oldPriceNumber: 14119910,
    firstText: 'Скидка 25%',
    secondText: 'Без отделки'
  },

  // добавлен (был в CSV, но отсутствовал в массиве)
  {
    image: '/assets/images/apartments/56,94.png',
    title: '2-комнатная, 56,94 м²',
    price: 'от 10,8 млн руб',
    oldPrice: 'от 14,5 млн руб',
    commonSpace: '56,94 м²',
    livingSpace: '35,39 м²',
    dialogTitle: 'Двухкомнатная квартира',
    priceNumber: 10847070,
    oldPriceNumber: 14462760,
    firstText: 'Скидка 25%',
    secondText: 'Без отделки'
  },
  {
    image: '/assets/images/apartments/4с_70,94.png',
    title: '3-комнатная, 70,94 м²',
    price: 'от 13,4 млн руб',
    oldPrice: 'от 17,9 млн руб',
    commonSpace: '70,94 м²',
    livingSpace: '40,76 м²',
    dialogTitle: 'Трехкомнатная квартира',
    priceNumber: 13407660,
    oldPriceNumber: 17876880,
    firstText: 'Скидка 25%',
    secondText: 'Без отделки'
  },
  {
    image: '/assets/images/apartments/60_76.png',
    title: '3-комнатная (евро), 60,76 м²',
    price: 'от 11,6 млн руб',
    oldPrice: 'от 15,4 млн руб',
    commonSpace: '60,76 м²',
    livingSpace: '39,69 м²',
    dialogTitle: 'Трехкомнатная квартира (евро)',
    priceNumber: 11574780,
    oldPriceNumber: 15433040,
    firstText: 'Скидка 25%',
    secondText: 'Без отделки'
  },

  // добавлен (был в CSV, но отсутствовал в массиве)
  {
    image: '/assets/images/apartments/3с_64,12.png',
    title: '3-комнатная, 64,12 м²',
    price: 'от 12,2 млн руб',
    oldPrice: 'от 16,3 млн руб',
    commonSpace: '64,12 м²',
    livingSpace: '41,76 м²',
    dialogTitle: 'Трехкомнатная квартира',
    priceNumber: 12214860,
    oldPriceNumber: 16286480,
    firstText: 'Скидка 25%',
    secondText: 'Без отделки'
  }
] satisfies Apartment[];

export const apartmentsFirstSecondList = [
  {
    image: "/assets/images/apartments/first-second/st/18-20.jpg",
    title: "Студия, 18,2 м²",
    price: "от 5,0 млн руб",
    oldPrice: "от 7,1 млн руб",
    commonSpace: "18,2 м²",
    livingSpace: "8,01 м²",
    dialogTitle: "Студия",
    firstText: "Скидка 30%",
    priceNumber: 4968600,
    oldPriceNumber: 7098000
  },
  {
    image: "/assets/images/apartments/first-second/st/19-73.jpg",
    title: "Студия, 19,73 м²",
    price: "от 5,0 млн руб",
    oldPrice: "от 7,2 млн руб",
    commonSpace: "19,73 м²",
    livingSpace: "8,01 м²",
    dialogTitle: "Студия",
    firstText: "Скидка 30%",
    priceNumber: 5013393,
    oldPriceNumber: 7161990
  },
  {
    image: "/assets/images/apartments/first-second/st/22-26.jpg",
    title: "Студия, 22,26 м²",
    price: "от 5,1 млн руб",
    oldPrice: "от 7,2 млн руб",
    commonSpace: "22,26 м²",
    livingSpace: "8,31 м²",
    dialogTitle: "Студия",
    firstText: "Скидка 30%",
    priceNumber: 5064150,
    oldPriceNumber: 7234500
  },

  {
    image: "/assets/images/apartments/first-second/1k/34-33.jpg",
    title: "1-комнатная, 34,33 м²",
    price: "от 6,5 млн руб",
    oldPrice: "от 9,3 млн руб",
    commonSpace: "34,33 м²",
    livingSpace: "11,9 м²",
    dialogTitle: "Однокомнатная квартира",
    firstText: "Скидка 30%",
    priceNumber: 6488370,
    oldPriceNumber: 9269100
  },
  {
    image: "/assets/images/apartments/first-second/1k/37-31.jpg",
    title: "1-комнатная, 37,31 м²",
    price: "от 6,8 млн руб",
    oldPrice: "от 9,7 млн руб",
    commonSpace: "37,31 м²",
    livingSpace: "16,73 м²",
    dialogTitle: "Однокомнатная квартира",
    firstText: "Скидка 30%",
    priceNumber: 6790420,
    oldPriceNumber: 9700600
  },
  {
    image: "/assets/images/apartments/first-second/1k/39-56.jpg",
    title: "1-комнатная, 39,56 м²",
    price: "от 6,9 млн руб",
    oldPrice: "от 9,9 млн руб",
    commonSpace: "39,56 м²",
    livingSpace: "16,34 м²",
    dialogTitle: "Однокомнатная квартира",
    firstText: "Скидка 30%",
    priceNumber: 6923000,
    oldPriceNumber: 9890000
  },
  {
    image: "/assets/images/apartments/first-second/1k/40-17.jpg",
    title: "1-комнатная, 40,17 м²",
    price: "от 7,0 млн руб",
    oldPrice: "от 10,0 млн руб",
    commonSpace: "40,17 м²",
    livingSpace: "15,52 м²",
    dialogTitle: "Однокомнатная квартира",
    firstText: "Скидка 30%",
    priceNumber: 7029750,
    oldPriceNumber: 10042500
  },

  {
    image: "/assets/images/apartments/first-second/2e/37-40.jpg",
    title: "2-комнатная (евро), 37,4 м²",
    price: "от 6,8 млн руб",
    oldPrice: "от 9,7 млн руб",
    commonSpace: "37,4 м²",
    livingSpace: "26,77 м²",
    dialogTitle: "Двухкомнатная квартира (евро)",
    firstText: "Скидка 30%",
    priceNumber: 6806800,
    oldPriceNumber: 9724000
  },
  {
    image: "/assets/images/apartments/first-second/2e/49-14.jpg",
    title: "2-комнатная (евро), 49,14 м²",
    price: "от 8,5 млн руб",
    oldPrice: "от 12,1 млн руб",
    commonSpace: "49,14 м²",
    livingSpace: "26,3 м²",
    dialogTitle: "Двухкомнатная квартира (евро)",
    firstText: "Скидка 30%",
    priceNumber: 8461908,
    oldPriceNumber: 12088440
  },
  {
    image: "/assets/images/apartments/first-second/2e/62-34.jpg",
    title: "2-комнатная (евро), 62,34 м²",
    price: "от 10,7 млн руб",
    oldPrice: "от 15,3 млн руб",
    commonSpace: "62,34 м²",
    livingSpace: "41,99 м²",
    dialogTitle: "Двухкомнатная квартира (евро)",
    firstText: "Скидка 30%",
    priceNumber: 10734948,
    oldPriceNumber: 15335640
  },
  {
    image: "/assets/images/apartments/first-second/2e/67-60.jpg",
    title: "2-комнатная (евро), 67,6 м²",
    price: "от 11,6 млн руб",
    oldPrice: "от 16,6 млн руб",
    commonSpace: "67,6 м²",
    livingSpace: "39,85 м²",
    dialogTitle: "Двухкомнатная квартира (евро)",
    firstText: "Скидка 30%",
    priceNumber: 11640720,
    oldPriceNumber: 16629600
  },

  {
    image: "/assets/images/apartments/first-second/3e/55-93.jpg",
    title: "3-комнатная (евро), 55,93 м²",
    price: "от 9,6 млн руб",
    oldPrice: "от 13,7 млн руб",
    commonSpace: "55,93 м²",
    livingSpace: "39,57 м²",
    dialogTitle: "Трёхкомнатная квартира (евро)",
    firstText: "Скидка 30%",
    priceNumber: 9631146,
    oldPriceNumber: 13758780
  },
  {
    image: "/assets/images/apartments/first-second/3e/61-37.jpg",
    title: "3-комнатная (евро), 61,37 м²",
    price: "от 10,6 млн руб",
    oldPrice: "от 15,1 млн руб",
    commonSpace: "61,37 м²",
    livingSpace: "42,97 м²",
    dialogTitle: "Трёхкомнатная квартира (евро)",
    firstText: "Скидка 30%",
    priceNumber: 10567914,
    oldPriceNumber: 15097020
  },
  {
    image: "/assets/images/apartments/first-second/3e/64-33.jpg",
    title: "3-комнатная (евро), 64,33 м²",
    price: "от 11,1 млн руб",
    oldPrice: "от 15,8 млн руб",
    commonSpace: "64,33 м²",
    livingSpace: "42,96 м²",
    dialogTitle: "Трёхкомнатная квартира (евро)",
    firstText: "Скидка 30%",
    priceNumber: 11077626,
    oldPriceNumber: 15825180
  },

  {
    image: "/assets/images/apartments/first-second/3k/74-58.jpg",
    title: "3-комнатная, 74,58 м²",
    price: "от 12,8 млн руб",
    oldPrice: "от 18,3 млн руб",
    commonSpace: "74,58 м²",
    livingSpace: "47,17 м²",
    dialogTitle: "Трёхкомнатная квартира",
    firstText: "Скидка 30%",
    priceNumber: 12842676,
    oldPriceNumber: 18346680
  },
  {
    image: "/assets/images/apartments/first-second/3k/77-54.jpg",
    title: "3-комнатная, 77,54 м²",
    price: "от 13,3 млн руб",
    oldPrice: "от 19,1 млн руб",
    commonSpace: "77,54 м²",
    livingSpace: "47,17 м²",
    dialogTitle: "Трёхкомнатная квартира",
    firstText: "Скидка 30%",
    priceNumber: 13352388,
    oldPriceNumber: 19074840
  },
  {
    image: "/assets/images/apartments/first-second/3k/78-06.jpg",
    title: "3-комнатная, 78,06 м²",
    price: "от 13,4 млн руб",
    oldPrice: "от 19,2 млн руб",
    commonSpace: "78,06 м²",
    livingSpace: "50,63 м²",
    dialogTitle: "Трёхкомнатная квартира",
    firstText: "Скидка 30%",
    priceNumber: 13441932,
    oldPriceNumber: 19202760
  },
  {
    image: "/assets/images/apartments/first-second/3k/83-32.jpg",
    title: "3-комнатная, 83,32 м²",
    price: "от 14,3 млн руб",
    oldPrice: "от 20,5 млн руб",
    commonSpace: "83,32 м²",
    livingSpace: "50,63 м²",
    dialogTitle: "Трёхкомнатная квартира",
    firstText: "Скидка 30%",
    priceNumber: 14347704,
    oldPriceNumber: 20496720
  }
] satisfies Apartment[];